export default function Tether() {
    return (
        <svg id="_15x15_photo_back" data-name="15x15 photo back" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0 0 15 15">
            <g id="Mask_Group_350" data-name="Mask Group 350">
                <path id="tether" d="M10.641,7.063V5.288h4.038v-2.8H3.47v2.8H7.52V7.063c-3.392.163-5.939.844-5.939,1.66s2.544,1.493,5.939,1.66v5.858h3.121V10.383c3.392-.162,5.939-.843,5.939-1.66S14.037,7.226,10.641,7.063ZM9.081,9.852c-3.673,0-6.652-.568-6.652-1.251,0-.589,2.169-1.083,5.088-1.215v2c.5.023,1.024.035,1.561.035s1.061-.013,1.561-.035v-2c2.919.132,5.088.626,5.088,1.215.006.691-2.972,1.251-6.646,1.251Z" transform="translate(-1.581 -1.864)" fill="#5d5d5d" />
            </g>
        </svg>

    )
}